import { render, staticRenderFns } from "./OrderKidsCasher.vue?vue&type=template&id=21f6e16c&scoped=true"
import script from "./OrderKidsCasher.vue?vue&type=script&lang=js"
export * from "./OrderKidsCasher.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsCasher.vue?vue&type=style&index=0&id=21f6e16c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f6e16c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f6e16c')) {
      api.createRecord('21f6e16c', component.options)
    } else {
      api.reload('21f6e16c', component.options)
    }
    module.hot.accept("./OrderKidsCasher.vue?vue&type=template&id=21f6e16c&scoped=true", function () {
      api.rerender('21f6e16c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsCasher.vue"
export default component.exports